import React, { useState, useEffect } from "react";
import { Modal, Input, Button, Switch, Space, Typography } from "antd";

const { TextArea } = Input;
const { Text } = Typography;

interface NewConversationModalProps {
  visible: boolean;
  onClose: () => void;
  onSubmit: (systemPrompt: string, assistantFirst: boolean, summaryMode: boolean, context: string, applicationName?: string) => void;
  modelCategory?: string;
}

const NewConversationModal: React.FC<NewConversationModalProps> = ({
  visible,
  onClose,
  onSubmit,
  modelCategory = "models",
}) => {
  const isAgent = modelCategory === "agents";
  const isFinetune = modelCategory === "finetunes";
  const [systemPrompt, setSystemPrompt] = useState("");
  const [assistantFirst, setAssistantFirst] = useState(false);
  const [summaryMode, setSummaryMode] = useState(false);
  const [context, setContext] = useState("");
  const [applicationName, setApplicationName] = useState("");

  useEffect(() => {
    if (isAgent || isFinetune) {
      setApplicationName("");
    }
  }, [isAgent, isFinetune]);

  const handleSubmit = () => {
    const finalApplicationName = (isAgent || isFinetune) ? "" : applicationName;
    onSubmit(systemPrompt, assistantFirst, summaryMode, context, finalApplicationName);
    setSystemPrompt("");
    setContext("");
    setApplicationName("");
    onClose();
  };

  return (
    <Modal
      title="New Conversation"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          Start Conversation
        </Button>,
      ]}
    >
      {!isAgent && !isFinetune && (
        <div>
          <p>Application Name:</p>
          <Input
            value={applicationName}
            onChange={(e) => setApplicationName(e.target.value)}
            placeholder="Enter application name (e.g., Customer Support Bot)"
          />
        </div>
      )}
      
      {!isAgent && (
        <>
          <div style={{ marginTop: "16px" }}>
            <p>Enter a system prompt for your new conversation:</p>
            <TextArea
              rows={6}
              value={systemPrompt}
              onChange={(e) => setSystemPrompt(e.target.value)}
              placeholder="You are a helpful assistant..."
            />
          </div>
          <div style={{ marginTop: "16px" }}>
            <p>Provide context for the conversation:</p>
            <TextArea
              rows={3}
              value={context}
              onChange={(e) => setContext(e.target.value)}
              placeholder="e.g., industry, names, technical terms, etc."
            />
          </div>
        </>
      )}
      
      <div style={{ marginTop: "16px" }}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Space>
            <Switch 
              checked={assistantFirst} 
              onChange={setAssistantFirst}
            />
            <Text>Assistant sends the first message</Text>
          </Space>
          <div style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.45)" }}>
            {assistantFirst 
              ? "The assistant will greet you when the conversation starts" 
              : "You'll start the conversation without an initial greeting from the assistant"}
          </div>
          
          <Space style={{ marginTop: "8px" }}>
            <Switch 
              checked={summaryMode} 
              onChange={setSummaryMode}
            />
            <Text>Conversation Summary Mode</Text>
          </Space>
        </Space>
      </div>
    </Modal>
  );
};

export default NewConversationModal; 